import { doc, onSnapshot } from 'firebase/firestore'
import { useContext, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'

import {
  LoginPage,
  // RequestPasswordResetPage,
  // PasswordResetEmailSentPage,
  ResetPasswordPage,
  LogoutPage,
  NewPasswordPage,
  ForgotPasswordPage,
} from './pages'
import { DefaultRoute } from '../../common/components/index'
import db from '../../configuration'
import { Maintenance } from '../../core/context/MaintenanceContext'
import MaintenancePage from '../../MaintenancePage'

// import AuthRoute from './AuthRoute';

const Account: React.FC = () => {
  const { maintenance, setMaintenance } = useContext(Maintenance)
  useEffect(() => {
    const docRef = doc(db, 'deploy_state', 'Y5QfzePx8MwaiHZytvof')
    const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const { isDeployInProgress } = docSnapshot.data()
        const maintenance = isDeployInProgress
        setMaintenance(maintenance)
      }
    })
    return () => {
      unsubscribe()
    }
  }, [setMaintenance])

  if (maintenance) {
    return <MaintenancePage />
  }

  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="logout" element={<LogoutPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="new-password" element={<NewPasswordPage />} />
      <Route path="*" element={<DefaultRoute />} />
      {/* <GuestRoute exact path="/account/forgot-password" component={RequestPasswordResetPage} /> */}
      {/* <GuestRoute exact path="/account/password-reset-email-sent" component={PasswordResetEmailSentPage} /> */}
    </Routes>
  )
}

export default Account
